


































import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import NavigationButton from "@/components/basic/buttons/NavigationButton.vue";
import File from "@/components/basic/fields/File.vue";
import Vue from "vue";
import { Action } from "@/constants/ajax";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";
import UploadError from "../UploadError.vue";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import HowToTakePicture from "@/components/HowToTakePicture.vue";
import { smartCapture, camera, gateway, fileSystem, view, result, initializing } from "@/libraries/websdk_templates";
import { translations } from "@/libraries/translations";

export default Vue.extend({
  name: "DesktopUpload",
  data() {
    return {
      documentType: null as DocumentType | null,
      action: null as null | Action,
      isPdfFile: false,
      showHowToTakePicture: true,
      gbgToken: "",
      clientId: "",
      info: "",
      showInfo: false,
      showLoader: true,
      isSecuringConnection: false,
      showHelp: false,
      manualAvailable: false,
      isPhotoUpload: false,
      isShowCamera: false,
      isShowWelcomeMessage: true,
      TRANSLATION_KEY: "steps.UploadDocumentFront",
      translationDictionary: {},
      gotCameraPermissions: false,
      noPermissions: false,
      helpAvailable: true,
      result: "",
      journeyEnd: false,
      sdkTranslations: translations.en,
      showCustomNotification: false,
      journeyId: '',
      isBadUpload: false,
      isBack: false,
      ignoreFirstJourneyProgress: true,
      backendUrl: '',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.commit(SET_PROGRESS, 6);
    this.blockCameraPermission();
    this.getToken();
    this.$store.state.isUploadDocumentStep = true;
    this.getTranslations();
  },

  methods: {

    getTranslations() {
      //@ts-ignore
      this.sdkTranslations = translations[UtilityHelper.getLocale()];
    },
    blockCameraPermission() {
      // Override getUserMedia to block camera access
      navigator.mediaDevices.getUserMedia = function() {
          return Promise.reject(new Error("NotAllowedError"));
      };

    },

    handleShowPopup() {
      this.$store.state.showInstructionPopup = true;
      this.showHelp = false;
    },
    async notifyJourney(journeyId: string, journeyStatus: string): Promise<any> {
      const ajaxService = this.$store.state.ajaxService;
      try {
        const data = await ajaxService.post(ajaxService.DOCUMENT_ROUTE + "notify-journey", {
          token: ajaxService.getToken(),
          journeyStatus: journeyStatus,
          journeyId: journeyId,
        });
        if(data.status === 'error') {
          this.$store.state.globalError = data.errors;
        }
      } catch (error) {
        this.$store.state.globalError = error;
      }
    },

    gbgSDK() {
      //@ts-ignore
      const onJourneyEventPro = (event, meta, state) => {
        switch (event) {
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.DISPLAY_STEP:
            if (state.inputProvider == "FILESYSTEM" && state.journey.currentResult == "Failed") {
              this.isBadUpload = true;
            } else {
              this.isBadUpload = false;
            }
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_STARTED:
            this.showLoader = true;
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_CANCEL:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_CLEAR:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_PROGRESS:
            if(!this.ignoreFirstJourneyProgress) {
              this.notifyJourney(this.journeyId, event);
            }
            this.ignoreFirstJourneyProgress = false;
            if (state.action == "IDENTITY:BACK") {
              this.isBack = true;
            } else {
              this.isBack = false;
            }
            // if (state.journey && typeof state.journey.journeyId !== "undefined") {
            //   this.notifyJourney(state.journey.journeyId, event);
            // }
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_START:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_END:
            this.$store.state.isGbg = false;
            this.$store.state.isUploadDocumentStep = false;
            this.$store.state.showLongDisclaimer = false;
            this.$store.state.isLocked = "active";
            if (this.journeyId.length > 0) {
              setTimeout(() => {
                fetch(`${this.backendUrl}idscanenterprisesvc/journey/get?journeyId=${this.journeyId}`, {
                  headers: { Authorization: this.gbgToken },
                })
                  .then((response: any) => {
                    response.json().then((data: any) => {
                      this.$store.state.clientIdData = data.ProcessedDocuments;
                      this.$store.state.isSubheaderVisible = true;
                      const journeyStatus = data.HighLevelResult.toLowerCase();
                      this.$store.state.isLocked = "";
                      const params = new URLSearchParams(window.location.search);
                      if (params.get("mobile") === "true") {
                        //Hybrid
                        this.$router.push({ name: 'mobileReturnToDesktop'});
                      } else {
                        if (journeyStatus === "passed") {
                          this.$router.push({ name: "uploadSucceeded" });
                        } else {
                          this.$router.push({ name: "uploadFailed" });
                        }
                      }
                    });
                  })
                  .catch((err: any) => {
                    console.error(err);
                  });
              }, 1000);
            } else {
              setTimeout(() => {
                this.$router.push({ name: "uploadFailed" });
                this.$store.state.isLocked = "";
              }, 10000);
            }
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_COMPLETE:
            this.showLoader = false;
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_FAILED:
            this.showLoader = false;
        }
      };

      const overrideTemplate = {
        smartCapture: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return smartCapture();
          },
        },
        camera: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return camera();
          },
        },
        gateway: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return gateway();
          },
        },
        filesystem: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return fileSystem();
          },
        },
        view: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return view();
          },
        },
        result: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return result();
          },
        },
        initializing: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return initializing();
          },
        },
      };

      //@ts-ignore
      new window.GBG.Idscan.JourneyContainer({
        backendUrl: `${this.backendUrl}`,
        container: "#gbgContainer",
        token: this.gbgToken,
        JourneyId: `"${this.journeyId}"`,
        onJourneyEvent: onJourneyEventPro,
        journeyDefinitionId: "887fa09f-e942-4d11-b937-84e8e4263415",
        smartCapture: {
          autoStart: true,
          timeout: 5000,
          workerScriptUrl: process.env.BASE_URL+"idscan/ides-micro.5533c29dc09364ea7b8e.js",
          asmScriptUrl: "idesmicro_asm.js",
        },
        manualCapture: {
          enabled: true,
          timeout: 15,
        },
        dictionary: this.sdkTranslations,
        hideAutoCaptureHints: false,
        isVerboseLogEnabled: true,
        templates: overrideTemplate,
        additionalData: [{
          Name: "TMSClientId",
          Value: this.clientId,
        }],
        assetsDirectory: process.env.BASE_URL+'assets',
        defaultInputProvider: "FILESYSTEM",
      }).initialize();
    },

    async getToken(): Promise<any> {
      const ajaxService = this.$store.state.ajaxService;
      let retryCount = 0;
      const maxRetries = 4;
      const fetchToken = async () => {
        try {
          const data = await ajaxService.post(ajaxService.DOCUMENT_ROUTE + "get-idscan-token", {
            token: ajaxService.getToken(),
          });

          if (data.status === "success") {
            this.gbgToken = data.gbgToken;
            this.journeyId = data.journeyId;
            this.clientId = data.clientId;
            this.backendUrl = data.backendUrl;
            this.gbgSDK();
            return data; // Success, return the data
          } else {
            if (retryCount < maxRetries) {
              retryCount++;
              setTimeout(fetchToken, 3000); // Retry after 3 seconds
            } else {
              // Handle non-success status
              // this.$store.state.globalError = "Failed to get token: " + data.errors;
              this.$router.push({ name: "uploadException" });
            }
          }
        } catch (error) {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(fetchToken, 3000); // Retry after 3 seconds
          } else {
            // this.$store.state.globalError = error;
            this.$router.push({ name: "uploadException" });
          }
        }
      }

      await fetchToken();
    },

    handlePopup(): void {
      this.$store.state.isPhotoInstructionsOpen = !this.$store.state.isPhotoInstructionsOpen;
    },

    handleHowToTakePicture() {
      this.isSecuringConnection = true;
      this.$store.state.analyticsService.sendStepEvent("howToTakePicture");
      this.showHowToTakePicture = !this.showHowToTakePicture;
      this.$store.state.isGbg = true;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.isSecuringConnection = false;
      }, 3000);
    },
  },
  computed: {
    ...mapState({
      isSkipAllowed: (state: any) => state.formData.isSkipAllowed,
      isPhotoInstructionsOpen: (state: any) => state.isPhotoInstructionsOpen,
      hasError: (state: any) => state.errors,
      isMobile: (state: any) => state.isDetectedMobileDevice,
      showPopup: (state: any) => state.showInstructionPopup,
      showInstructions: (state: any) => state.showInstructions,
      securityPopup: (state: any) => state.showSecurityPopup,
      isGbg: (state: any) => state.isGbg,
      isUploadDocumentStep: (state: any) => state.isUploadDocumentStep,
      showLongDisclaimer: (state: any) => state.showLongDisclaimer,
    }),
    UtilityHelper() {
      return UtilityHelper;
    },
  },
  components: {
    File,
    SubmitButton,
    NavigationButton,
    UploadError,
    HowToTakePicture
  },
});
